import _debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { Item } from '../../search';

const _filterItems = (items: Item[], text) => {
	return items.filter(item => item.value?.toLowerCase().includes(text?.toLowerCase()));
};

const delay = 300;

const debounceSet = _debounce((set, evaluateValue) => {
	set(evaluateValue());
}, delay);

const useDebouncedFilterItems = (items: Item[], text: string) => {
	const [matchedItems, setMatchedItems] = useState<Item[]>([]);

	useEffect(() => {
		if (text === '') {
			setMatchedItems([]);
		} else {
			debounceSet(setMatchedItems, () => _filterItems(items, text));
			return debounceSet.cancel;
		}
	}, [items, text]);

	return matchedItems;
};

export default useDebouncedFilterItems;
